
interface ContentErrorProps {
  message: string;
}

/**
 * Error display component for content loading issues
 */
const ContentError = ({ message }: ContentErrorProps) => {
  if (!message) return null;
  
  return <div className="text-red-500">Error: {message}</div>;
};

export default ContentError;
